import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import FirstRunTourGate from "./FirstRunTourGate";
import ConnectBankSheet from "./ConnectBankSheet";
import ReviewSheet from "./ReviewSheet";
import EmailLinkSheets from "./EmailLinkSheets";
import { t } from "../i18n";

// Loged
export const RequireAuth: React.FC = () => {
  const { isAuthenticated, loading, user } = useContext(AuthContext);
  const location = useLocation();
  if (loading) return <p>{t("routeGuards.loading")}</p>;
  // Stripe REJECTED (KYC fail, sanctions): the one terminal state, asked live
  // by the server on login and on every resumed session (GET /auth/user).
  if (isAuthenticated && user?.stripeRejected && location.pathname !== "/stripe-rejected") {
    return <Navigate to="/stripe-rejected" replace state={{ code: user.stripeRejectionCode }} />;
  }
  // FREE TIER: a talent whose bank setup is unfinished (needsStripeFinish), or
  // who skipped the bank at signup, is NOT sent anywhere. They use the app
  // with free requests, and every money button opens one of two sheets
  // (lib/connectBank): ConnectBankSheet, then ReviewSheet.
  // FirstRunTourGate sequences the first sign-in: the once-per-
  // account first-run tour, then the Phase C price popup (PriceSetupModal)
  // for accounts still on their registration placeholder. Mounted HERE —
  // the one place every authenticated DJ page flows through — so every
  // return path (Stripe callback login, plain login, resume links) meets it.
  // It renders nothing once both are behind the account.
  // EmailLinkSheets: the onboarding emails' ?payouts=1 / ?refer=1 buttons.
  // After the two sheets, so they are listening before a link opens one.
  if (isAuthenticated)
    return (
      <>
        <FirstRunTourGate />
        <ConnectBankSheet />
        <ReviewSheet />
        <EmailLinkSheets />
        <Outlet />
      </>
    );
  // Preserve where the talent was headed (e.g. /requests from a new-request
  // SMS link) so LoginPage can return them there after a single login instead
  // of dropping them on /profile. The query rides along, so an email's
  // /requests?payouts=1 still opens its sheet after the sign-in.
  const next = encodeURIComponent(location.pathname + location.search);
  return <Navigate to={`/login?next=${next}`} replace />;
};

// Guests
export const RequireNoAuth: React.FC = () => {
  const { isAuthenticated, loading } = useContext(AuthContext);
  if (loading) return <p>{t("routeGuards.loading")}</p>;
  return !isAuthenticated ? <Outlet /> : <Navigate to="/profile" replace />;
};
